import { UploadedFileResponse } from '../../../api/types/cms';
import { FormControl, InputLabel, Stack } from '@mui/material';
import FileUpload from '../../qlive/FileUpload';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';
import { FormFieldProps } from './index';

export default function FileUploadFormField({
    type,
    name,
    label,
    attr,
    disabled,
    value,
    help,
    required,
    onChange,
    multiple,
}: FormFieldProps) {
    const { translate } = useTranslation();
    const onSuccess = useCallback(
        (
            uploadedFiles:
                | Array<UploadedFileResponse>
                | UploadedFileResponse
                | null,
        ) => {
            if (!onChange) return;
            onChange(uploadedFiles);
        },
        [onChange],
    );

    return useMemo(
        () => (
            <FormControl fullWidth>
                <Stack spacing={0.5}>
                    <InputLabel shrink sx={{ mt: 0.5 }}>
                        {translate(label)}
                    </InputLabel>
                    <FileUpload
                        fieldConfig={{
                            type,
                            name,
                            label,
                            disabled,
                            required,
                            attr,
                            value,
                            multiple,
                        }}
                        uploadToPool={attr ? attr['file-pool'] : undefined}
                        multiple={multiple}
                        onSuccess={onSuccess}
                        accept={attr ? attr['accept'] : undefined}
                    />
                </Stack>
            </FormControl>
        ),
        [
            attr,
            disabled,
            label,
            multiple,
            name,
            onSuccess,
            required,
            translate,
            type,
            value,
        ],
    );
}
